<template>
  <b-modal
    ref="modal"
    centered
    no-close-on-backdrop
    hide-header
    hide-footer
    modal-class="card-style bg-light vas-login-modal-component text-dark"
    :visible="isLoggingIn"
    @hidden="hideLogin"
    @shown="reset"
  >
    <template>
      <section class="header-section row">
        <div class="col-3">
          <img src="/logo.png" alt="xbuzzi-logo">
        </div>
        <div class="col-9 mt-3">
          <h5 class="modal-title">
            {{ $t('security.loginModalTitle') }}
          </h5>
        </div>
      </section>

      <div class="d-flex flex-column align-items-center px-3">
        <SubscriptionLoading :is-loading="isLoading" />

        <PhoneNumberInput
          v-show="isShowingPhoneNumberInput && !isLoading"
          ref="phoneNumberInput"
          :phone-number-input-text="PhoneNumberInputText"
        />

        <h6 v-show="isShowingPhoneNumberInput && !isLoading && isMultiPlanProviderCode" class="pb-2 w-100">{{ $t('security.loginModalChooseOperator')  }}</h6>

        <b-form-group v-show="isShowingPhoneNumberInput && !isLoading && isMultiPlanProviderCode">
          <b-form-radio-group>
             <template v-for="optr in operators" >
               <div class="text-center d-inline-block mx-2">
                 <img :src="require(`@/assets/logos/${optr.logoName}`)" :alt="optr.name" class="d-block"  width="70">
                 <b-form-radio v-model="operator" class="ml-4" :value="optr.code">
                 </b-form-radio>
               </div>
           </template>
          </b-form-radio-group>
        </b-form-group>

        <b-alert v-show="chooseOperatorError" fade show variant="danger">
           <small>{{ $t('security.operatorIsUnchoosen') }}</small>
        </b-alert>
        <b-button
          v-if="isShowingPhoneNumberInput"
          variant="primary"
          size="lg"
          class="w-100 mb-1"
          @click="checkPhoneNumber"
        >
          {{ $t('security.loginButtonText') }}
        </b-button>

        <PinInput :pinLength="pinLength"  v-show="isShowingPinInput && !isLoading" ref="pinInput" />
        <b-button
          v-if="isShowingPinInput"
          variant="success"
          size="lg"
          class="w-100"
          @click="checkPin"
        >
          {{ $t('security.confirmPinButtonText') }}
        </b-button>
        <b-button
          :disabled="resendBtn"
          v-if="isShowingPinInput"
          variant="secondary"
          size="sm"
          class="w-100 mt-2"
          @click="resendPin"
        >
          {{ $t('security.reSendPin') }}
        </b-button>
      </div>
      <div class="d-flex flex-column px-3">
        <div v-if="isShowingPinInput && !isLoading" class="d-flex align-self-center mb-3">
          <b-link class="text-secondary" @click="reset">
            <small>{{ $t('security.changePhoneNumber') }}</small>
          </b-link>
        </div>
        <small class="mb-3">
          {{ designConfig.pages.vasLogin.configurations.footerText }}
        </small>
        <div v-if="isShowingPhoneNumberInput" class="d-flex align-self-center justify-content-center mb-3">
          <b-link class="text-muted" to="/TermsAndConditions" target="_blank">
            <small>{{ $t('security.termsAndConditions') }}</small>
          </b-link>
        </div>
        <div class="line" />
        <section class="footer-section d-flex flex-row justify-content-center">
          <b-link class="mt-4 mb-2" @click="close">
            {{ $t('security.backToHomePage') }}
          </b-link>
        </section>
      </div>
    </template>
  </b-modal>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import utility from '@/utilities/utility'
import PhoneNumberInput from '@/components/PhoneNumberInput.vue'
import PinInput from '@/components/PinInput.vue'
import SubscriptionLoading from '@/components/SubscriptionLoading.vue'

export default Vue.extend({
  name: 'VasLoginModal',
  components: {
    PhoneNumberInput,
    PinInput,
    SubscriptionLoading
  },
  data () {
    return {
      isLoading: false,
      isShowingPhoneNumberInput: true,
      isShowingPinInput: false,
      userUniqueIdentifier: '',
      userName: '',
      PhoneNumberInputText: 'security.phoneNumberInputText',
      requestResult: {},
      operator: null,
      operators:[],
      isMultiPlanProviderCode: false,
      choosenPlanProviderCode: null,
      requestCode: null,
      checkBtn: false,
      resendBtn: true,
      time: 30,
      pinLength: 8,
      chooseOperatorError: null
    }
  },
  computed: {
    ...mapGetters({
      designConfig: 'tenantDesign/config',
      isLoggingIn: 'navigation/isLoggingIn'
    }),
    phoneNumberInput () {
      return this.$refs.phoneNumberInput
    },
    phoneNumber () {
      return this.phoneNumberInput.phoneNumber
    },
    pinInput () {
      return this.$refs.pinInput
    },
    pin () {
      return this.pinInput.pin
    }
  },
  created(){
    if(Array.isArray(this.designConfig.userManagement.vas.planProviderCode)){
      this.isMultiPlanProviderCode = true
      this.operators = this.designConfig.userManagement.vas.planProviderCode.map((ppc) => {
        return ppc
      })
    }
  },
  methods: {
    ...mapActions({
      getUserStatus: 'subscription/getUserStatus',
      request: 'subscription/requestForSubscription',
      initSub: 'subscription/init',
      resendSub: 'subscription/resend',
      verify: 'subscription/verify',
      checkRequestStatus: 'subscription/checkRequestStatus',

      // initSub: 'subscription/initSub',
      // confirmSub: 'subscription/confirmSub',
      // getSubStatus: 'subscription/getSubStatus',

      authenticateVasUser: 'auth/authenticateVasUser',

      hideLogin: 'navigation/hideLogin'
    }),
    close () {
      this.$refs.modal.hide()
    },
    reset () {
      this.isShowingPhoneNumberInput = true
      this.isShowingPinInput = false
      this.isLoading = false
      this.phoneNumberInput.phoneNumber = ''
      this.pinInput.pin = ''
      this.refCode = utility.createGUID()
      this.resendBtn = true
      this.checkBtn = false
    },

    resendPin () {
      this.isLoading = true
      let ppc = null
      if (this.operator)
        ppc = this.operator
      else
        ppc = this.designConfig.userManagement.vas.planProviderCode
      let Payload = {
         RequesterServiceRefCode: this.requestCode,
         deviceType: 'None',
         userName: this.phoneNumber,
         planProviderCode: ppc,
         isEmail: false
      }
      this.resendSub(Payload).then(Response => {
        this.isLoading = false
        this.time = 30
        this.countDownTimer()
      })
    },
    countDownTimer () {
      if (this.time > 0) {
        this.resendBtn = true
        this.checkBtn = false
        setTimeout(() => {
          this.time -= 1
          this.countDownTimer()
        }, 1000)
      } else {
        this.resendBtn = false
        this.checkBtn = true
      }
    },
    checkPhoneNumber () {
      if (this.phoneNumber.length < 9) {
        this.phoneNumberInput.showInputError()
        return
      }
      this.chooseOperatorError = false
      this.checkUserSubscription()
    },
    checkUserSubscription () {
      this.isLoading = true
      let payload = {
        userName: this.phoneNumber
      }
      this.getUserStatus(payload).then(response => {
        let result = response.body.result

        // TODO: check whether user is subscribed or not
        let userPlans = result.filter(r => r.state === 'Subscribe')
        if (userPlans.length > 0) {
          this.userUniqueIdentifier = userPlans[0].userUniqueIdentifier
          this.userName = userPlans[0].userName
          this.login()
        } else {
           if (this.isMultiPlanProviderCode && !this.operator){
             this.isLoading = false
             this.chooseOperatorError = true
             return
           }
          this.processUnsubscribedUser()
        }
      })
    },
    processUnsubscribedUser () {
      let ppc = null
      if (this.operator)
        ppc = this.operator
      else
        ppc = this.designConfig.userManagement.vas.planProviderCode
      let payload = {
        planProviderCode: ppc,
        pageCode: this.designConfig.userManagement.vas.pageCode,
        channel: 'Portal',
        channelName: window.location.hostname
      }

      this.request(payload).then(response => {
        let result = response.body.result
        this.requestResult = result
        this.requestCode = result.code
        if(result.pinLength > 0)
          this.pinLength = result.pinLength

        // TODO: Remove country code from payload
        if (result.subscriptionMethod === 'Otp') {
          let initPayload = {
            code: result.code,
            deviceType: 'None',
            userName: this.phoneNumber,
            isEmail: false
          }
            this.initSub(initPayload).then(initResponse => {
            this.countDownTimer()
            this.isLoading = false
            this.isShowingPhoneNumberInput = false
            this.isShowingPinInput = true
          })
        } else if (result.subscriptionMethod === 'CG') {
          window.location.href = result.redirectUrl
        }
      })
    },
    checkPin () {
      if (this.pin.length < 4) {
        this.pinInput.showInputError()
        return
      }

      this.isLoading = true
      let confirmInput = {
        requesterServiceRefCode: this.requestResult.code,
        userInput: this.pin
      }

      this.verify(confirmInput)
        .then(response => {
          this.checkConfirmStatus()
        })
        .catch(err => {
          // TODO: Show an alert message about failure in send confirm request
          // Failed to send confirm request
          if (err) {
            this.reset()
          }
        })
    },
    checkConfirmStatus () {
      this.checkRequestStatus(this.requestResult.code).then(response => {
        let result = response.body.result

        if (result === 'Failed') {
          // TODO: Show an alert message about failure in sub request
          // Failed to confirm
          this.reset()
        }
        if (result === 'FailedVerification') {
          this.isLoading = false
          this.isShowingPinInput = true
          this.isShowingPhoneNumberInput = false
        } else if (result === 'Finalized') {
          this.checkUserSubscription()
        } else {
          setTimeout(() => {
            this.checkConfirmStatus()
          }, 2000)
        }
      })
    },
    login () {
      this.authenticateVasUser(this.userName)
        .then(response => {
          let result = response.body.result

          if (result.resultType === 'Success') {
            this.isLoading = false
            this.close()
          } else if (result.resultType === 'InvalidUserNameOrPassword') {
            // Waiting for identity user to be created
            setTimeout(() => {
              this.login()
            }, 2000)
          } else {
            this.isLoading = false
          }
        })
        .catch(error => {
          this.isLoading = false
        })
        .finally(() => {})
    }
  }
})
</script>
